import { ValidateIf } from "class-validator";
// import { ValidationMetadata } from 'class-validator/esm5/metadata/ValidationMetadata';
// class-validator has IsOptional provider, but it only allows undefined and null values to pass.
// to allow empty strings to pass as well, a custom validator is required.
// see https://github.com/typestack/class-validator/issues/326
export function AllowEmpty(validationOptions) {
  return ValidateIf((obj, value) => {
    return value !== null && value !== undefined && value !== '';
  }, validationOptions);
}
// export function AllowEmpty(validationOptions?: ValidationOptions): PropertyDecorator {
// 	// setup as suggested by manual
// 	return function (object: object, propertyName: string): void {
// 		registerDecorator({
// 			name:'conditionalValidation', // same as type: ValidationTypes.CONDITIONAL_VALIDATION, (which is unsupported by registerDecorator)
// 			target: object.constructor,
// 			propertyName: propertyName,
// 			constraints: [
// 			  // eslint-disable-next-line @typescript-eslint/no-shadow
// 			  (obj: any, value: any): boolean => {
// 				return obj[propertyName] !== null && obj[propertyName] !== undefined && obj[propertyName] !== '';
// 			  },
// 			],
// 			options: validationOptions,
// 			validator:()=>true,
// 		});
// 	};
//   }